// desctructure the paths

export const settingsRoutes = []
